import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Mariana G.',
    text: 'Llevaba meses hinchada sin importar lo que comiera. En la primera semana ya noté la diferencia. Simple, claro y efectivo.'
  }, {
    name: 'Laura P.',
    text: 'Pensé que era algo que tenía que aceptar. Esta guía me mostró que no. Mi digestión cambió completamente.'
  }, {
    name: 'Sofía R.',
    text: 'Las recetas son riquísimas y fáciles. No sentí que estaba haciendo una dieta, y aun así mi abdomen bajó.'
  }, {
    name: 'Valeria M.',
    text: 'Lo que más me gustó es que explica el POR QUÉ. Entender lo que le pasaba a mi cuerpo fue un cambio total.'
  }];
  return <section className="w-full bg-white py-14 px-4 md:px-8" data-id="element-217">
      <div className="max-w-5xl mx-auto" data-id="element-218">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-2xl md:text-3xl font-serif text-text-dark text-center mb-8" data-id="element-219">
          Miles de mujeres ya están sintiéndose más livianas
        </motion.h2>

        <div className="grid sm:grid-cols-2 gap-5" data-id="element-220">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="bg-bg-soft p-6 rounded-2xl border border-secondary-light/20" data-id="element-221">
              <div className="flex items-center gap-0.5 mb-3" data-id="element-222">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-223" />)}
              </div>
              <p className="text-primary-mid text-sm leading-relaxed mb-4" data-id="element-224">
                "{t.text}"
              </p>
              <p className="text-xs text-primary-mid/60 font-medium" data-id="element-225">
                — {t.name}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}